module.exports = __webpack_public_path__ + "static/media/shortlink4.9aabcff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Creating/shortlink4.jpg
// module id = 1623
// module chunks = 0